const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  SPACE,
  COMMA
} = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'Indonesia',
  code: 'ID',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town', width: 0.5 },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address', COMMA, 'address2'],
    ['city', SPACE, 'zipCode']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['city', 'zipCode']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 numbers, 40198'
    }
  ]
};
